// Custom error class for API errors
export class ApiError extends Error {
  statusCode: number;
  errors?: { [field: string]: string[] };

  constructor(message: string, statusCode: number, errors?: { [field: string]: string[] }) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.errors = errors;
  }
}
